import React from 'react'

import type { InventoryOrder } from '~/api/graphql/generated/types'

import { OrderItemsPageHeaderLabels } from './order-items/OrderItemsPageHeaderLabels'

interface OrderCardProps {
  inventoryOrder: InventoryOrder
}

export const OrderCard = ({ inventoryOrder }: OrderCardProps) => (
  <OrderItemsPageHeaderLabels inventoryOrder={inventoryOrder} />
)
